(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["learning-section"] && !Shopify.designMode) return;
  try {
    
  // Optional: JS for tab switching

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parent-choice"] && !Shopify.designMode) return;
  try {
    
  /* Not required for this section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const select = document.getElementById('classSelect');
    const grid = document.getElementById('productsGrid');

    function initSlick() {
      if (window.innerWidth < 640) {
        if (!$(grid).hasClass('slick-initialized')) {
          $(grid).slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
          });
        }
      } else {
        if ($(grid).hasClass('slick-initialized')) {
          $(grid).slick('unslick');
        }
      }
    }

    async function filterProducts(tag) {
      const collectionHandle = window.collectionHandle || 'all';
      let url;
      
      if (tag === 'all') {
        // For "All Classes", get all products and filter client-side for product-listing tags
        url = `/collections/${collectionHandle}?view=ajax-grid`;
      } else {
        // For specific class, get products with both class tag and "all" tag
        url = `/collections/${collectionHandle}?filter.p.tag=${tag}&filter.p.tag=all&view=ajax-grid`;
      }

      grid.classList.add('loading');
      try {
        const res = await fetch(url);
        const html = await res.text();

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = parsed.querySelector('.products-grid');

        if (newGrid) {
          // Destroy old Slick instance
          if ($(grid).hasClass('slick-initialized')) {
            $(grid).slick('unslick');
          }

          let products = Array.from(newGrid.children);
          
          if (tag === 'all') {
            // Filter for product-listing tags and sort by order
            products = products.filter(el => {
              const tags = el.dataset.tags || '';
              return tags.includes('product-listing-1') || 
                     tags.includes('product-listing-2') || 
                     tags.includes('product-listing-3');
            });
            
            products.sort((a, b) => {
              const getListingOrder = (el) => {
                const tags = el.dataset.tags || '';
                if (tags.includes('product-listing-1')) return 1;
                if (tags.includes('product-listing-2')) return 2;
                if (tags.includes('product-listing-3')) return 3;
                return 999;
              };
              return getListingOrder(a) - getListingOrder(b);
            });
            products = products.slice(0, 3);
          }
          products = products.slice(0, 3);

          grid.innerHTML = '';
          products.forEach(product => grid.appendChild(product));
          
          setTimeout(initSlick, 100);
        }
      } catch (err) {
        console.error('Error fetching filtered products:', err);
      } finally {
        grid.classList.remove('loading');
      }
    }

    // Initial load
    filterProducts('all');

    select.addEventListener('change', function () {
      filterProducts(this.value);
    });

    window.addEventListener('resize', function () {
      setTimeout(initSlick, 200);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
